import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchTitle: {
		id: 'servicedesk.knowledge-hub.common.knowledge-base-search-breadcrumb.search-title',
		defaultMessage: 'Search',
		description: 'Title for the search result scoped breadcrumb',
	},
});
